var config = {
    // loginCheck: false,
    cordova: "ytycordovafalse",
    loginCheck: true,
    // url: 'http://localhost:8019',
    url: "https://wxservice.yunsiwei.com",
    // url: "http://192.168.1.10:8010",
    wechat:'https://api.weixin.qq.com/wxa'
}
export default config


// WEBPACK FOOTER //
// ./src/config.js